import {
    Formik,
    // Field
} from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { RegContainer, RegForms, RegisterSection } from '../components/Authentication/AuthStyles';
// import logo from '../assets/bigLogo.svg';
import {
    Backbutton,
    HeaderContainer,
} from '../components/LandingPageComponents/styles/HeaderStyles';
import { backbtn } from './dashboard/components/Icons';
import { Box, Heading, Text, Spinner } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../redux/actions/authActions';
import RegForm from 'components/LandingPageComponents/desktop/RegForm';
import { useScreenWidth } from 'hooks/useScreenWidth';

const ForgotPassword = () => {
    const validationSchema = Yup.object().shape({
        user_identification: Yup.string(),
        // .required('An email address or phone number is required')
        // .user_identification('Enter a valid email address or phone number')
    });

    const initialValues = { user_identification: '' };
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const forgotPasswordReducer = useSelector((state) => state.forgotPasswordReducer);
    const { user, loading } = forgotPasswordReducer;

    const screen = useScreenWidth();

    useEffect(() => {
        if (user) {
            navigate('/reset-password');
        }
    }, [user, navigate]);

    return (
        <RegContainer>
            <RegisterSection>
                {screen <= 500 && (
                    <HeaderContainer style={{ padding: 0 }}>
                        <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                    </HeaderContainer>
                )}
                {screen <= 500 && (
                    <Box>
                        <Heading
                            as="h1"
                            fontSize="32px"
                            fontWeight="700"
                            color="#090A0A"
                            mt="0px"
                            mb="8px">
                            Forgot Password
                        </Heading>
                        <Text Text color="#2C2C2C" fontSize="14px" mb="10px">
                            Don’t Worry! It happens. Please enter the address associated with your
                            account.
                        </Text>
                    </Box>
                )}
                <RegForm>
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            setSubmitting(true);
                            let data = {
                                user_identification: values.email,
                            };
                            setSubmitting(false);
                            // console.log(data);
                            dispatch(forgotPassword(data));
                        }}>
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            setFieldTouched,
                        }) => (
                            <div className="form-sect">
                                {screen > 500 && (
                                    <>
                                        <div style={{ padding: '2rem 4rem', float: 'right' }}>
                                            <Link to="/login">
                                                <Text fontSize="16px" fontWeight="500">
                                                    Go Back
                                                </Text>
                                            </Link>
                                        </div>
                                    </>
                                )}
                                <RegForms
                                    style={{ marginTop: screen > 500 ? '30%' : '5%' }}
                                    onSubmit={handleSubmit}>
                                    <div className="border-group">
                                        {screen > 500 && (
                                            <div
                                                style={{
                                                    marginTop: '1rem',
                                                    marginBottom: '2rem',
                                                    textAlign: 'center',
                                                }}>
                                                <Heading
                                                    color="#090A0A"
                                                    fontSize="24px"
                                                    lineHeight="36px">
                                                    Forgot Password
                                                </Heading>
                                                <Text
                                                    color="#090A0A"
                                                    fontSize="14px"
                                                    lineHeight="24px">
                                                    Don’t Worry! It happens. Please enter the
                                                    address associated with your account.
                                                </Text>
                                            </div>
                                        )}
                                        <div className="form-group">
                                            <label htmlFor="email">Email/Phone Number</label>
                                            <div>
                                                <input
                                                    type="text"
                                                    name="email"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    inputMode="email"
                                                />
                                            </div>
                                        </div>{' '}
                                        <div className="error-message">
                                            {touched.email && errors.email}
                                        </div>
                                        <hr />
                                        <button
                                            type="submit"
                                            className="sign-in-button"
                                            disabled={loading}>
                                            {!loading ? (
                                                'Submit'
                                            ) : (
                                                <Spinner color="light" size="sm" />
                                            )}
                                        </button>
                                    </div>
                                </RegForms>
                            </div>
                        )}
                    </Formik>
                </RegForm>
            </RegisterSection>
        </RegContainer>
    );
};

export default ForgotPassword;
